// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__OdIsC","subheader":"ReorderModal_subheader__1CQGY","listWrap":"ReorderModal_listWrap__19aP9"};